import { getWindow } from '@fluentui/react';
import Envs from '@agoras/envs';

function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var Logger = /*#__PURE__*/ function() {
    function Logger() {
        _class_call_check(this, Logger);
        _define_property(this, "_instance", void 0);
        _define_property(this, "_context", void 0);
    }
    _create_class(Logger, [
        {
            key: "init",
            value: function init(instance, config) {
                var _Envs_getConfig_telemetryEnv;
                this._instance = instance;
                this._context = {
                    config: config
                };
                var correlationId = config.correlationId, hostType = config.hostType, visitorId = config.visitorId;
                this._instance.getPropertyManager().setProperty('correlationId', correlationId);
                this._instance.getPropertyManager().setProperty('hostType', hostType);
                this._instance.getPropertyManager().setProperty('visitorId', visitorId || '');
                this._instance.getPropertyManager().setProperty('environment', ((_Envs_getConfig_telemetryEnv = Envs.getConfig().telemetryEnv) === null || _Envs_getConfig_telemetryEnv === void 0 ? void 0 : _Envs_getConfig_telemetryEnv.toLowerCase()) || '');
            }
        },
        {
            key: "setContext",
            value: function setContext(context) {
                this._context = _object_spread({}, this._context, context);
            }
        },
        {
            key: "log",
            value: function log(level, message, payload) {
                var _getWindow, _getWindow1, _getWindow2, _getWindow3, _this__context_user, _this__context, _this__context_user1, _this__context1, _this__instance;
                var _ref = payload || {}, _ref_collection = _ref.collection, collection = _ref_collection === void 0 ? 'Telemetry' : _ref_collection;
                if (!this._instance) {
                    console.error('You must use init function before!');
                }
                (_this__instance = this._instance) === null || _this__instance === void 0 ? void 0 : _this__instance.trackEvent({
                    name: "".concat(Envs.getConfig().telemetryEnv, ".").concat(collection)
                }, _object_spread({
                    host: ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.host) || '',
                    browserLanguage: ((_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.navigator.language) || '',
                    userAgent: ((_getWindow2 = getWindow()) === null || _getWindow2 === void 0 ? void 0 : _getWindow2.navigator.userAgent) || '',
                    page: ((_getWindow3 = getWindow()) === null || _getWindow3 === void 0 ? void 0 : _getWindow3.location.href) || '',
                    clientTimestamp: new Date().toISOString(),
                    tid: ((_this__context = this._context) === null || _this__context === void 0 ? void 0 : (_this__context_user = _this__context.user) === null || _this__context_user === void 0 ? void 0 : _this__context_user.tid) || '',
                    isLoggedIn: !!((_this__context1 = this._context) === null || _this__context1 === void 0 ? void 0 : (_this__context_user1 = _this__context1.user) === null || _this__context_user1 === void 0 ? void 0 : _this__context_user1.signedIn),
                    level: level,
                    details: message
                }, payload));
            }
        },
        {
            key: "info",
            value: function info(message, payload) {
                this.log('Info', message, payload);
            }
        },
        {
            key: "warning",
            value: function warning(message, payload) {
                this.log('Warning', message, payload);
            }
        },
        {
            key: "debug",
            value: function debug(message, payload) {
                this.log('Debug', message, payload);
            }
        },
        {
            key: "error",
            value: function error(message, payload) {
                this.log('Error', message, payload);
            }
        }
    ]);
    return Logger;
}();

export { Logger as default };
